"use client";

import { typeByExtension } from "@std/media-types";
import type { ComponentProps } from "react";

export interface VideoPlayerProps extends ComponentProps<"video"> {
	src: string;
}

const getStreamVideoUrl = (url: string) => {
	return `https://streams.frend.dev/video/v1?url=${encodeURIComponent(url)}`;
};

const getMimeType = (url: string) => {
	const mimeType = typeByExtension(url.split(".").pop() || "");
	return mimeType;
};

export const VideoPlayer = ({ src, ...rest }: VideoPlayerProps) => {
	return (
		<div className="relative h-full w-full">
			<video
				autoPlay
				loop
				muted
				playsInline
				{...rest}
				className="absolute inset-0 h-full w-full object-cover"
			>
				<source src={getStreamVideoUrl(src)} type={getMimeType(src)} />
				<source src={getStreamVideoUrl(src)} />
			</video>
		</div>
	);
};
